import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'

const BlushEmoji = (props: IIconProps) => (
  <BaseIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <circle id="a" cx="12" cy="12" r="12" />
      <filter id="b" width="200%" height="200%" x="-50%" y="-50%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
      </filter>
      <filter id="d" width="200%" height="200%" x="-50%" y="-50%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <mask id="c" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#FFC200" xlinkHref="#a" />
        <circle
          cx="3.5"
          cy="14.5"
          r="4.5"
          fill="#F26752"
          fillRule="nonzero"
          filter="url(#b)"
          mask="url(#c)"
          opacity=".5"
        />
        <circle
          cx="20.5"
          cy="14.5"
          r="4.5"
          fill="#F26752"
          fillRule="nonzero"
          filter="url(#d)"
          mask="url(#c)"
          opacity=".5"
        />
      </g>
      <path
        fill="#FFF"
        d="M18.975 12.367a6.893 6.893 0 0 1-.353 2.801 7.262 7.262 0 0 1-1.452 2.476 7.133 7.133 0 0 1-2.324 1.728A6.938 6.938 0 0 1 12 20a6.932 6.932 0 0 1-2.846-.628 7.137 7.137 0 0 1-2.323-1.728 7.269 7.269 0 0 1-1.453-2.476 6.9 6.9 0 0 1-.353-2.806.39.39 0 0 1 .422-.356c.19.017.336.17.353.356.152 1.67.88 3.217 2.013 4.33C8.94 17.805 10.46 18.47 12 18.455c1.54.015 3.06-.65 4.188-1.763 1.133-1.115 1.86-2.655 2.012-4.334a.39.39 0 0 1 .423-.356c.19.017.335.17.351.356l.001.01z"
      />
      <path
        fill="#263740"
        d="M9.563 7.875A.562.562 0 0 1 9 7.312a1.69 1.69 0 0 0-1.688-1.687 1.69 1.69 0 0 0-1.687 1.688.562.562 0 1 1-1.125 0A2.816 2.816 0 0 1 7.313 4.5a2.816 2.816 0 0 1 2.812 2.813c0 .31-.252.562-.563.562M18.938 7.875a.562.562 0 0 1-.563-.563 1.69 1.69 0 0 0-1.688-1.687A1.69 1.69 0 0 0 15 7.313a.562.562 0 1 1-1.125 0A2.816 2.816 0 0 1 16.688 4.5 2.816 2.816 0 0 1 19.5 7.313c0 .31-.252.562-.563.562"
      />
    </g>
  </BaseIcon>
)

export default BlushEmoji
